import React from 'react'
import { Typography } from '@mui/material';
import ScrollToTop from "react-scroll-to-top"; 
import './Footer.css'
import { SocialMedia } from '../Comp/AllComponents';

const Footer = () => {
    return (
        <>

            <Typography
            className='socialFooter'
                variant='div'
                component={'div'}
            >
                <Typography
                 className='sociaIconlFooter'
                    variant='div'
                    component={'div'}
                    sx={{
                        alignItems:'center',
                        justifyContent:'center'
                    }}
                >

                    <SocialMedia />
                    
                    
                     
                </Typography>
            </Typography>


            <Typography
                variant='div'
                component={'div'}
            >
                <Typography
                    variant='h6'
                    component={'h6'}
                    sx={{
                        textAlign: 'center',
                        backgroundColor: '#360161',
                        color: 'white',
                        pt: 4,
                        pb: 2
                    }}
                >
                   &copy; 2024 Abhishek | All Rights Reserved
                </Typography>
                <ScrollToTop 
                smooth 
                color='white'
                style={{backgroundColor:'#fe5000',fontWeight:'bold', borderRadius:'70px'}} />

            </Typography>          
    </>
  )
}

export default Footer
